export const consumableEn = {
  "Note": "Note",
  "Donner une note si vous voulez": "Give a note ..",
  "Fournisseur": "Supplier",
  "Consommable": "Consumable",
  "Quantité": "Quantity",
  "Total BC": "Total P.O",
  "Total Payé": "Total Payed",
  "BC": "P.O",
  "Les bons de commandes": "Purchases Orders",
  "Cacher": "Hide",
  "Afficher": "Show",
  "Historique de paiements": "History of Payments",
  "Reference": "Reference",
  "List Consommable": "List Consumable",
  "Fournisseurs": "Suppliers",
  "Debut": "Start",
  "Fin": "End",
  "Jour": "Day",
  "Mois": "Month",
  "Bon de commande": "Purchase Order",

  
  // Server Side 

  "Le consomable deja existe.": "The consumable already exists.",
  "Le nom du consomable est obligatoire !!": "The name of the consumable is mandatory!!",
  "Le montant est obligatoire": "The amount is mandatory",
  "Le fournisseur est obligatoire": "Supplier is required",
  "Les donneés du bon de commande sont obligatoire.": "The purchase order details are mandatory.",
  "Donner une date valide": "Give a valid date",

  "Le Fournisseur deja existe": "The Supplier already exists",
  "Le nom du fournisseur est obligatoire": "Supplier name is required",
  "Le Telephone du fournisseur est obligatoire": "The supplier's telephone number is required",

  "Supprimer tous les bons de commandes de ce fournisseur, pour pouvoir le supprimer.": "Delete all purchase orders from this supplier, to be able to delete it.",
  


}